document.documentElement.classList.remove('no-js');

/* ---------- Helpers ---------- */
function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
function qsa(sel, ctx) { return Array.from((ctx || document).querySelectorAll(sel)); }

/* ---------- Drawer toggling (cart, search, mobile menu) ---------- */
function toggleDrawer(el, show) {
  if (!el) return;
  el.hidden = show === undefined ? !el.hidden : !show;
}

const cartToggle = qs('.header-cart-toggle');
const cartDrawer = qs('#CartDrawer');
if (cartToggle && cartDrawer) {
  cartToggle.addEventListener('click', () => toggleDrawer(cartDrawer, true));
  qsa('[data-cart-drawer-close]', cartDrawer).forEach(btn =>
    btn.addEventListener('click', () => toggleDrawer(cartDrawer, false))
  );
}

const searchToggle = qs('.header-search-toggle');
const searchDrawer = qs('#SearchDrawer');
if (searchToggle && searchDrawer) {
  searchToggle.addEventListener('click', () => {
    toggleDrawer(searchDrawer);
    const input = qs('input[type="search"]', searchDrawer);
    if (!searchDrawer.hidden && input) input.focus();
  });
}

const menuToggle = qs('.header-menu-toggle');
const mobileNav = qs('#MobileNav');
if (menuToggle && mobileNav) {
  menuToggle.addEventListener('click', () => {
    toggleDrawer(mobileNav);
    const expanded = menuToggle.getAttribute('aria-expanded') === 'true';
    menuToggle.setAttribute('aria-expanded', String(!expanded));
  });
}

/* ---------- Product gallery: thumbnail swap ---------- */
qsa('.product-page__thumb').forEach(thumb => {
  thumb.addEventListener('click', () => {
    const url = thumb.getAttribute('data-image-url');
    const mainImg = qs('#ProductMainImage');
    if (url && mainImg) mainImg.src = url;
  });
});

/* ---------- Add to cart (AJAX) with cart drawer refresh ---------- */
async function addToCart(variantId, quantity) {
  const res = await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: quantity || 1 })
  });
  if (!res.ok) throw new Error('Kon product niet toevoegen aan winkelwagen');
  return res.json();
}

async function refreshCartDrawer() {
  const cartRes = await fetch('/cart.js');
  const cart = await cartRes.json();

  qsa('[data-cart-count]').forEach(el => {
    el.textContent = cart.item_count;
    el.hidden = cart.item_count === 0;
  });

  const footer = qs('[data-cart-drawer-footer]');
  if (footer) footer.hidden = cart.item_count === 0;

  const subtotalEl = qs('[data-cart-subtotal]');
  if (subtotalEl) {
    subtotalEl.textContent = new Intl.NumberFormat('nl-NL', { style: 'currency', currency: cart.currency || 'EUR' }).format(cart.total_price / 100);
  }

  const itemsWrap = qs('[data-cart-drawer-items]');
  if (!itemsWrap) return;

  if (cart.item_count === 0) {
    itemsWrap.innerHTML = '<p class="cart-drawer__empty">Je winkelwagen is nog leeg.</p>';
    return;
  }

  itemsWrap.innerHTML = cart.items.map(item => `
    <div class="cart-drawer__item">
      ${item.image ? `<img src="${item.image}" alt="${item.product_title}" width="70" height="70" loading="lazy">` : ''}
      <div class="cart-drawer__item-info">
        <a href="${item.url}">${item.product_title}</a>
        <span>${item.quantity} &times; ${(item.price / 100).toFixed(2)}</span>
      </div>
    </div>
  `).join('');
}

/* Product form (main product page) */
const productForm = qs('#ProductForm');
if (productForm) {
  productForm.addEventListener('submit', async (e) => {
    e.preventDefault();
    const variantInput = qs('[data-variant-id]', productForm);
    const qtyInput = qs('input[name="quantity"]', productForm);
    const submitBtn = qs('button[type="submit"]', productForm);
    const originalText = submitBtn.textContent;
    submitBtn.disabled = true;
    submitBtn.textContent = 'Toevoegen...';
    try {
      await addToCart(variantInput.value, parseInt(qtyInput.value, 10) || 1);
      await refreshCartDrawer();
      toggleDrawer(qs('#CartDrawer'), true);
    } catch (err) {
      alert('Er ging iets mis bij het toevoegen aan de winkelwagen.');
    } finally {
      submitBtn.disabled = false;
      submitBtn.textContent = originalText;
    }
  });
}

/* Quick-add buttons on product cards */
qsa('[data-quick-add-btn]').forEach(btn => {
  btn.addEventListener('click', async () => {
    const wrapper = btn.closest('product-quick-add');
    const variantId = wrapper && wrapper.getAttribute('data-variant-id');
    if (!variantId) return;
    const originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Toevoegen...';
    try {
      await addToCart(variantId, 1);
      await refreshCartDrawer();
      toggleDrawer(qs('#CartDrawer'), true);
    } catch (err) {
      alert('Er ging iets mis bij het toevoegen aan de winkelwagen.');
    } finally {
      btn.disabled = false;
      btn.textContent = originalText;
    }
  });
});

/* ---------- Popular products carousel controls ---------- */
qsa('[data-carousel]').forEach(track => {
  const wrap = track.closest('.popular-products');
  if (!wrap) return;
  const prevBtn = qs('[data-carousel-prev]', wrap);
  const nextBtn = qs('[data-carousel-next]', wrap);
  const scrollAmount = () => (qs('.carousel__item', track) ? qs('.carousel__item', track).offsetWidth + 20 : 260);
  if (prevBtn) prevBtn.addEventListener('click', () => track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' }));
  if (nextBtn) nextBtn.addEventListener('click', () => track.scrollBy({ left: scrollAmount(), behavior: 'smooth' }));
});

/* ---------- Mobile nav accordion ---------- */
qsa('.mobile-nav__toggle').forEach(toggle => {
  toggle.addEventListener('click', (e) => {
    // Let clicks on the link itself navigate normally
    if (e.target.tagName === 'A') return;
    const li = toggle.closest('.mobile-nav__top');
    const sub = qs('.mobile-nav__sub', li);
    if (!sub) return;
    const isOpen = li.classList.toggle('is-open');
    sub.hidden = !isOpen;
    toggle.setAttribute('aria-expanded', String(isOpen));
  });
});

/* ---------- Gift finder: redirect to filtered collection ---------- */
const giftFinderForm = qs('[data-gift-finder]');
if (giftFinderForm) {
  giftFinderForm.addEventListener('submit', (e) => {
    e.preventDefault();
    const age = qs('#GiftFinderAge').value;
    const interest = qs('#GiftFinderInterest').value;
    const tags = [age, interest].filter(Boolean);
    if (tags.length === 0) {
      window.location.href = '/collections/all';
      return;
    }
    window.location.href = '/collections/all/' + tags.map(t => 'tagged_' + t).join('+');
  });
}

/* ---------- Price range filter (slider + min/max inputs) ---------- */
qsa('[data-price-filter]').forEach(box => {
  const minSlider = qs('[data-price-min-slider]', box);
  const maxSlider = qs('[data-price-max-slider]', box);
  const minInput = qs('[data-price-min-input]', box);
  const maxInput = qs('[data-price-max-input]', box);
  const trackFill = qs('[data-price-track-fill]', box);
  const applyBtn = qs('[data-price-apply]', box);
  const rangeMax = parseFloat(box.dataset.rangeMax) || 100;
  if (!minSlider || !maxSlider) return;

  function clamp(val, min, max) {
    if (isNaN(val)) return min;
    return Math.min(Math.max(val, min), max);
  }

  function updateTrackFill() {
    const minVal = parseFloat(minSlider.value) || 0;
    const maxVal = parseFloat(maxSlider.value) || rangeMax;
    const minPct = (minVal / rangeMax) * 100;
    const maxPct = (maxVal / rangeMax) * 100;
    trackFill.style.left = minPct + '%';
    trackFill.style.right = (100 - maxPct) + '%';
  }

  function slidersFromInputs() {
    let minVal = clamp(parseFloat(minInput.value), 0, rangeMax);
    let maxVal = clamp(parseFloat(maxInput.value), 0, rangeMax);
    if (minVal > maxVal) minVal = maxVal;
    minInput.value = minVal;
    maxInput.value = maxVal;
    minSlider.value = minVal;
    maxSlider.value = maxVal;
    updateTrackFill();
  }

  minSlider.addEventListener('input', () => {
    if (parseFloat(minSlider.value) > parseFloat(maxSlider.value)) {
      minSlider.value = maxSlider.value;
    }
    minInput.value = minSlider.value;
    updateTrackFill();
  });

  maxSlider.addEventListener('input', () => {
    if (parseFloat(maxSlider.value) < parseFloat(minSlider.value)) {
      maxSlider.value = minSlider.value;
    }
    maxInput.value = maxSlider.value;
    updateTrackFill();
  });

  minInput.addEventListener('input', slidersFromInputs);
  maxInput.addEventListener('input', slidersFromInputs);

  function applyPriceFilter() {
    const params = new URLSearchParams(window.location.search);
    const minParam = box.dataset.minParam;
    const maxParam = box.dataset.maxParam;
    const minVal = clamp(parseFloat(minInput.value), 0, rangeMax);
    const maxVal = clamp(parseFloat(maxInput.value), 0, rangeMax);

    if (minVal > 0) {
      params.set(minParam, minVal);
    } else {
      params.delete(minParam);
    }
    if (maxVal < rangeMax) {
      params.set(maxParam, maxVal);
    } else {
      params.delete(maxParam);
    }
    params.delete('page');
    window.location.href = window.location.pathname + '?' + params.toString();
  }

  if (applyBtn) applyBtn.addEventListener('click', applyPriceFilter);
  maxInput.addEventListener('keydown', (e) => { if (e.key === 'Enter') applyPriceFilter(); });
  minInput.addEventListener('keydown', (e) => { if (e.key === 'Enter') applyPriceFilter(); });

  updateTrackFill();
});

/* ---------- Productaanbevelingen ophalen (Shopify recommendations API) ---------- */
qsa('[data-product-recommendations]').forEach(async (section) => {
  const url = section.dataset.url;
  if (!url) return;
  try {
    const res = await fetch(url);
    if (!res.ok) return;
    const html = await res.text();
    const temp = document.createElement('div');
    temp.innerHTML = html;
    const newContent = temp.querySelector('[data-product-recommendations]');
    if (newContent && newContent.innerHTML.trim()) {
      section.innerHTML = newContent.innerHTML;
    }
  } catch (err) {
    // Stil falen: sectie blijft dan gewoon leeg/onzichtbaar
  }
});

/* ---------- Sticky header (JS-gestuurd, robuust tegen overflow elders) ---------- */
(function () {
  const header = qs('.site-header');
  const announcementBar = qs('.announcement-bar');
  if (!header) return;

  const triggerPoint = announcementBar ? announcementBar.offsetHeight : 0;
  let isPinned = false;
  let ticking = false;

  function updateHeader() {
    const shouldPin = window.scrollY > triggerPoint;
    if (shouldPin && !isPinned) {
      const headerHeight = header.offsetHeight;
      header.classList.add('is-pinned');
      document.body.style.paddingTop = headerHeight + 'px';
      isPinned = true;
    } else if (!shouldPin && isPinned) {
      header.classList.remove('is-pinned');
      document.body.style.paddingTop = '';
      isPinned = false;
    }
    header.classList.toggle('is-scrolled', window.scrollY > 4);
    ticking = false;
  }

  window.addEventListener('scroll', () => {
    if (!ticking) {
      window.requestAnimationFrame(updateHeader);
      ticking = true;
    }
  }, { passive: true });

  window.addEventListener('resize', updateHeader);
  updateHeader();
})();